<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Add New Shop </template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="12">
              <b-row>
                <b-col class="py-3 text-center">
                  <span
                    style="font-size: 20px; font-weight: 500; color: #a7a7a7"
                  >
                    Login Details
                  </span>
                </b-col>
              </b-row>
              <b-row class="justify-content-md-center">
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('AdminName') }">
                    <b-form-group>
                      <label>Admin Name</label>
                      <b-form-input
                        v-model="AdminName"
                        type="text"
                        id="AdminName"
                        placeholder="Admin Name"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('AdminName')"
                      >
                        <span style="color: red">{{
                          validation.firstError("AdminName")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('AdminPhone') }">
                    <b-form-group>
                      <label>Admin Phone</label>
                      <b-form-input
                        v-model="AdminPhone"
                        type="number"
                        id="AdminPhone"
                        placeholder="Admin Phone"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('AdminPhone')"
                      >
                        <span style="color: red">{{
                          validation.firstError("AdminPhone")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('AdminEmail') }">
                    <b-form-group>
                      <label>Admin Email</label>
                      <b-form-input
                        v-model="AdminEmail"
                        type="email"
                        id="AdminEmail"
                        placeholder="Admin Email"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('AdminEmail')"
                      >
                        <span style="color: red">{{
                          validation.firstError("AdminEmail")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Username') }">
                    <b-form-group>
                      <label>Username</label>
                      <b-form-input
                        v-model="Username"
                        type="text"
                        id="Username"
                        placeholder="Username"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Username')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Username")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Password') }">
                    <b-form-group>
                      <label>Password</label>
                      <b-form-input
                        v-model="Password"
                        type="password"
                        id="Password"
                        placeholder="Password"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Password')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Password")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <!-- Basic Details -->
              <b-row>
                <b-col class="py-3 text-center">
                  <span
                    style="font-size: 20px; font-weight: 500; color: #a7a7a7"
                  >
                    Basic Details
                  </span>
                </b-col>
              </b-row>

              <b-row class="justify-content-md-center">
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Name') }">
                    <b-form-group>
                      <label>Name</label>
                      <b-form-input
                        v-model="Name"
                        type="text"
                        id="Name"
                        placeholder="Name"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Name')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Name")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Website') }">
                    <b-form-group>
                      <label>Website</label>
                      <b-form-input
                        v-model="Website"
                        type="text"
                        id="Website"
                        placeholder="Website"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Website')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Website")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('MobileNo') }">
                    <b-form-group>
                      <label>Phone No </label>
                      <b-form-input
                        v-model="MobileNo"
                        type="number"
                        id="MobileNo"
                        placeholder="Phone No"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('MobileNo')"
                      >
                        <span style="color: red">{{
                          validation.firstError("MobileNo")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('ShopName') }">
                    <b-form-group>
                      <label>Shop Name</label>
                      <b-form-input
                        v-model="ShopName"
                        type="text"
                        id="ShopName"
                        placeholder="Shop Name"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('ShopName')"
                      >
                        <span style="color: red">{{
                          validation.firstError("ShopName")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{ error: validation.hasError('Description') }">
                    <b-form-group>
                      <label>Description</label>
                      <b-form-textarea
                        v-model="Description"
                        type="text"
                        id="description"
                        placeholder="Description"
                      ></b-form-textarea>
                      <template
                        slot="description"
                        v-if="validation.firstError('Description')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Description")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- Address Details -->
          <b-row>
            <b-col class="pt-4 py-3 text-center">
              <span style="font-size: 20px; font-weight: 500; color: #a7a7a7">
                Address Details
              </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('Addr1') }">
                <b-form-group>
                  <label>Address</label>
                  <b-form-input
                    v-model="Addr1"
                    type="text"
                    id="Addr1"
                    placeholder="Address"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('Addr1')"
                  >
                    <span style="color: red">{{
                      validation.firstError("Addr1")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('Addr2') }">
                <b-form-group>
                  <label>Address 2</label>
                  <b-form-input
                    v-model="Addr2"
                    type="text"
                    id="Addr2"
                    placeholder="Address 2"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('Addr2')"
                  >
                    <span style="color: red">{{
                      validation.firstError("Addr2")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('Pincode') }">
                <b-form-group>
                  <label>Pincode</label>
                  <b-form-input
                    v-model="Pincode"
                    type="text"
                    id="Pincode"
                    placeholder="Pincode"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('Pincode')"
                  >
                    <span style="color: red">{{
                      validation.firstError("Pincode")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('latitude') }">
                <b-form-group>
                  <label>Latitude</label>
                  <b-form-input
                    v-model="latitude"
                    type="text"
                    id="latitude"
                    placeholder="latitude"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('latitude')"
                  >
                    <span style="color: red">{{
                      validation.firstError("latitude")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('longitude') }">
                <b-form-group>
                  <label>Longitude</label>
                  <b-form-input
                    v-model="longitude"
                    type="text"
                    id="longitude"
                    placeholder="longitude"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('longitude')"
                  >
                    <span style="color: red">{{
                      validation.firstError("longitude")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
          </b-row>

          <!-- Social Media Details -->
          <b-row>
            <b-col class="pt-4 py-3 text-center">
              <span style="font-size: 20px; font-weight: 500; color: #a7a7a7">
                Social Media Details
              </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('Facebook') }">
                <b-form-group>
                  <label>Facebook URL</label>
                  <b-form-input
                    v-model="Facebook"
                    type="text"
                    id="facebook"
                    placeholder="Facebook URL"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('Facebook')"
                  >
                    <span style="color: red">{{
                      validation.firstError("Facebook")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('Instagram') }">
                <b-form-group>
                  <label>Instagram URL</label>
                  <b-form-input
                    v-model="Instagram"
                    type="text"
                    id="instagram"
                    placeholder="Instagram URL"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('Instagram')"
                  >
                    <span style="color: red">{{
                      validation.firstError("Instagram")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('Twitter') }">
                <b-form-group>
                  <label>Twitter URL</label>
                  <b-form-input
                    v-model="Twitter"
                    type="text"
                    id="twitter"
                    placeholder="Twitter URL"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('Twitter')"
                  >
                    <span style="color: red">{{
                      validation.firstError("Twitter")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
          </b-row>

          <!-- Shipment Details -->
          <b-row>
            <b-col class="pt-4 py-3 text-center">
              <span style="font-size: 20px; font-weight: 500; color: #a7a7a7">
                Shipment Details
              </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('max_free_distance') }">
                <b-form-group>
                  <label>Max Free Distance</label>
                  <b-form-input
                    v-model="max_free_distance"
                    type="text"
                    id="max_free_distance"
                    placeholder="Max Free Distance"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('max_free_distance')"
                  >
                    <span style="color: red">{{
                      validation.firstError("max_free_distance")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div :class="{ error: validation.hasError('charge_per_meter') }">
                <b-form-group>
                  <label>Charge Per Meter</label>
                  <b-form-input
                    v-model="charge_per_meter"
                    type="text"
                    id="charge_per_meter"
                    placeholder="Charge Per Meter"
                  />
                  <template
                    slot="description"
                    v-if="validation.firstError('charge_per_meter')"
                  >
                    <span style="color: red">{{
                      validation.firstError("charge_per_meter")
                    }}</span>
                  </template>
                </b-form-group>
              </div>
            </b-col>
          </b-row>

          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click.prevent="validateInput"
              >
                Create Shop
              </b-button>
            </div>
          </b-row>

          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,

      AdminName: null,
      AdminPhone: null,
      AdminEmail: null,
      Username: null,
      Password: null,

      Name: null,
      Description: null,
      Website: null,
      MobileNo: null,
      ShopName: null,

      Facebook: null,
      Instagram: null,
      Twitter: null,
      max_free_distance: null,
      charge_per_meter: null,
      Addr1: null,
      Addr2: null,
      Pincode: null,
      latitude: null,
      longitude: null,
    };
  },

  validators: {
    AdminName(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(1)
        .maxLength(120);
    },
    AdminPhone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .integer()
        .minLength(10)
        .maxLength(12);
    },
    AdminEmail(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .email("Provide a valid email address.");
    },
    Username(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[A-Za-z]", "Please Input Valid Username.")
        .minLength(4)
        .maxLength(128);
    },
    Password(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(8)
        .maxLength(128);
    },
    Name(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[A-Za-z]", "Please Input Valid Name.")
        .minLength(1)
        .maxLength(120);
    },
    Description(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(50)
        .maxLength(512);
    },
    Website(value) {
      return this.Validator.value(value).url().maxLength(1024);
    },
    MobileNo(value) {
      return this.Validator.value(value)
        .integer()
        .required("Required Field")
        .minLength(10)
        .maxLength(12);
    },
    ShopName(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[a-zA-Z0-9]", "Please Input Valid Shop Name.")
        .minLength(1)
        .maxLength(120);
    },
    Facebook(value) {
      return this.Validator.value(value).url();
    },
    Instagram(value) {
      return this.Validator.value(value).url();
    },
    Twitter(value) {
      return this.Validator.value(value).url();
    },
    max_free_distance(value) {
      return this.Validator.value(value).required("Required Field");
    },
    charge_per_meter(value) {
      return this.Validator.value(value).required("Required Field");
    },
    Addr1(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[A-Za-z0-9]", "Please Input Valid Address.")
        .maxLength(256);
    },
    Addr2(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[A-Za-z0-9]", "Please Input Valid Address.")
        .maxLength(256);
    },
    Pincode(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .maxLength(16);
    },
    latitude(value) {
      return this.Validator.value(value).required("Required Field");
    },
    longitude(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },
  methods: {
    validateInput() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.addShop();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    addShop() {
      this.appLoading = true;
      var shop = {};
      shop["admin_name"] = this.AdminName;
      shop["admin_phone"] = this.AdminPhone;
      shop["admin_email"] = this.AdminEmail;
      shop["username"] = this.Username;
      shop["password"] = this.Password;
      shop["name"] = this.Name;
      shop["description"] = this.Description;
      shop["website"] = this.Website;
      shop["mobileno"] = this.MobileNo;
      shop["shop_name"] = this.ShopName;
      shop["facebook"] = this.Facebook;
      shop["instagram"] = this.Instagram;
      shop["twitter"] = this.Twitter;
      shop["addr1"] = this.Addr1;
      shop["addr2"] = this.Addr2;
      shop["pincode"] = this.Pincode;
      shop["lat"] = parseFloat(this.latitude);
      shop["lon"] = parseFloat(this.longitude);
      shop['max_free_distance']=parseFloat(this.max_free_distance)
      shop['charge_per_meter']=parseFloat(this.charge_per_meter)
      axios({
        method: "POST",
        url: "/shop",
        data: shop,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "Shop Created Successfully",
              text: "",
              type: "success",
            });
            this.$router.push("/Shops");
          } else {
            this.$notify({
              group: "appNotification",
              title: response.data.msg,
              text: "",
              type: "error",
            });
          }
          console.log(response);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>
